var map = {
	"./0.png": 2914,
	"./1.png": 8470,
	"./10.png": 124,
	"./2.png": 4274,
	"./3.png": 6864,
	"./4.png": 6597,
	"./5.png": 4878,
	"./6.png": 7376,
	"./7.png": 8285,
	"./8.png": 7512,
	"./9.png": 2060,
	"./activity.png": 1789,
	"./aeroport.png": 3160,
	"./ancient.png": 4792,
	"./artobject.png": 9360,
	"./binoculars.png": 7199,
	"./buildings.png": 5870,
	"./burial.png": 7970,
	"./busstation.png": 645,
	"./child.png": 9739,
	"./church.png": 7408,
	"./custom.png": 196,
	"./distance.png": 8986,
	"./duration.png": 9754,
	"./food.png": 3913,
	"./gorge.png": 6016,
	"./grocery.png": 155,
	"./horse.png": 7030,
	"./hospital.png": 1262,
	"./hotel.png": 17,
	"./icons8-aircraft-50.png": 6697,
	"./icons8-финишный-флажок-50.png": 2222,
	"./marker.png": 6115,
	"./monument.png": 3444,
	"./mosque.png": 109,
	"./nature.png": 8916,
	"./overnight.png": 5985,
	"./pray.png": 1626,
	"./railway.png": 8122,
	"./restourant.png": 2064,
	"./sanctum.png": 9810,
	"./seats.png": 8548,
	"./ski.png": 9775,
	"./start_finish.png": 5580,
	"./swing.png": 8001,
	"./tower.png": 4221,
	"./transport.png": 1403,
	"./viewpoint.png": 6843,
	"./waterfall.png": 9123,
	"./zoo.png": 2959
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4020;